import React from "react";
import { Box, Typography, Button, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useOutletContext } from "react-router-dom";
import aa from "../../assets/images/aa.png";
import marksheet from "../../assets/images/marksheet.png";
import esign from "../../assets/images/esign.png";
import ckyc from "../../assets/images/ckyc.png";
import enach from "../../assets/images/enach.png";
import degreeFetch from "../../assets/images/degree.png";
import ocr from "../../assets/images/ocr.png";
import pan from "../../assets/images/pan.png";
import drivingFetch from "../../assets/images/dl.png";
import facefinder from "../../assets/images/facefinder.png";
import aadharFetch from "../../assets/images/aadharFetch.png";
import HeroMeonDocs from "../../assets/images/HeroDoc.png";
import startSvg from "../../assets/images/star.svg";

// Products configuration
const products = [
  {
    id: 1,
    name: "Face Verification Api",
    description:
      "Instantly validate identities using secure facial recognition",
    icon: facefinder,
    navigationLink: "/products/Meon Face Verification",
  },
  {
    id: 2,
    name: "Aadhaar eSign API",
    description: "Enable trusted, paperless document signing via Aadhaar",
    icon: esign,
    navigationLink: "/products/eSign",
  },
  {
    id: 3,
    name: "Marksheet verification API",
    description: "Automate marksheet checks to streamline the onboarding flow",
    icon: marksheet,
    navigationLink: "/products/Educational Documents Fetch",
  },
  {
    id: 4,
    name: "Aadhaar Fetch through Digilocker API",
    description:
      "Access authentic Aadhaar information straight from Digilocker.",
    icon: aadharFetch,
    navigationLink: "/products/Aadhaar Fetch",
  },
  {
    id: 5,
    name: "Pan Fetch through Digilocker API",
    description: "Securely retrieve verified PAN card details from Digilocker",
    icon: pan,
    navigationLink: "/products/Pan API",
  },
  {
    id: 6,
    name: "Degree/Diploma Certificate Fetch through Digilocker API",
    description: "Verify academic credentials easily with DigiLocker fetch",
    icon: degreeFetch,
    navigationLink: "/products/Degree/Diploma Certificate Fetch",
  },
  {
    id: 7,
    name: "Driving License Fetch through Digilocker API",
    description:
      "Instantly access verified license data via the DigiLocker API",
    icon: drivingFetch,
    navigationLink: "/products/Driving License Fetch",
  },
  {
    id: 8,
    name: "OCR (Optical Character Recognition) API",
    description: "Accurately extract text from scanned documents and images",
    icon: ocr,
    navigationLink: "/products/OCR",
  },
  {
    id: 9,
    name: "Account Aggregator (AA) API Integration",
    description: "Securely access user financial data via AA integration",
    icon: aa,
    navigationLink: "/products/Meon Account Aggregator.",
  },
  {
    id: 10,
    name: "C-KYC Fetch / Update Integration",
    description: "Access verified KYC data or update records via one API",
    icon: ckyc,
    navigationLink: "/products/CKYC Integration",
  },
  {
    id: 11,
    name: "Income tax PAN API",
    description: "Instantly validate PAN for seamless compliance checks.",
    icon: pan,
    navigationLink: "/products/PAN API",
  },
  {
    id: 12,
    name: "Enach Integration",
    description: "Streamline recurring payments with secure eNACH APIs",
    icon: enach,
    navigationLink: "/products/Enach Integration",
  },
];

// Product Card Component
const ProductCard = ({ product, onNavigate, isMobile, isTablet }) => (
  <Box
    sx={{
      width: "100%",
      maxWidth: "360px",
      height: "100%",
      minHeight: isMobile ? "auto" : "520px",
      borderRadius: isMobile ? "1.25rem" : "1.875rem",
      display: "flex",
      flexDirection: "column",
      position: "relative",
      overflow: "visible",
      transition: "all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
      padding: "3px",
      background:
        "linear-gradient(153deg, rgba(24, 92, 183, 1) 0%, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 1) 80%, rgba(205, 48, 77, 1) 100%)",
      "&:hover": {
        transform: "scale(0.97)",
        boxShadow:
          "0 8px 32px rgba(24, 92, 183, 0.15), 0 4px 16px rgba(205, 48, 77, 0.1)",
      },
      "&:active": {
        transform: "scale(0.95)",
      },
      // Keyframes
      "@keyframes shine": {
        "0%": {
          transform: "translateX(-150%) translateY(-150%) rotate(45deg)",
          opacity: 0,
        },
        "50%": {
          opacity: 1,
        },
        "100%": {
          transform: "translateX(150%) translateY(150%) rotate(45deg)",
          opacity: 0,
        },
      },
    }}
  >
    <Box
      sx={{
        background: "#FFFFFF",
        width: "100%",
        height: "100%",
        borderRadius: isMobile ? "calc(1.25rem - 3px)" : "calc(1.875rem - 3px)",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        transition: "all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
        "&:hover": {
          // background: "rgba(255, 255, 255, 0.7)",
          // backdropFilter: "blur(30px) saturate(180%)",
          // WebkitBackdropFilter: "blur(30px) saturate(180%)",
          // boxShadow:
          //   "inset 0 0 80px rgba(24, 92, 183, 0.08), inset 0 0 40px rgba(193, 21, 64, 0.05)",
          // // Trigger shine animation on hover
          "&::before": {
            animation: "shine 1.8s ease-in-out",
          },
          "&::after": {
            opacity: 1,
          },
        },
        // Shine effect overlay
        "&::before": {
          content: '""',
          position: "absolute",
          top: "-50%",
          left: "-50%",
          width: "200%",
          height: "200%",
          background:
            "linear-gradient(135deg, transparent 0%, transparent 40%, rgba(255, 255, 255, 0.8) 50%, transparent 60%, transparent 100%)",
          pointerEvents: "none",
          zIndex: 10,
          opacity: 0,
        },
        // Glassy gradient overlay
        "&::after": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            "radial-gradient(circle at 30% 30%, rgba(24, 92, 183, 0.12) 0%, transparent 50%), radial-gradient(circle at 70% 70%, rgba(193, 21, 64, 0.08) 0%, transparent 50%)",
          pointerEvents: "none",
          zIndex: 1,
          opacity: 0,
          transition: "opacity 0.5s ease",
        },
      }}
    >
      {/* Top illustration section */}

      <Box
        sx={{
          background:
            "linear-gradient(113.1deg, rgba(24, 92, 183, 0.06) 0%, rgba(205, 48, 77, 0.06) 100%)",
          flex: isMobile ? "0 0 auto" : "1 1 auto",
          aspectRatio: isMobile ? "16 / 9" : "auto",
          minHeight: isMobile ? "auto" : "270px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          borderRadius: isMobile
            ? "calc(1.25rem - 3px) calc(1.25rem - 3px) 0 0"
            : "calc(1.875rem - 3px) calc(1.875rem - 3px) 0 0",
          overflow: "hidden",
          padding: isMobile ? "1.3rem" : "1.0rem",
        }}
      >
        {/* Product image/mockup */}
        <Box
          sx={{
            borderRadius: isMobile ? "1rem" : "1.25rem",
            background: "#FFFFFF",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            boxShadow: "0 6px 20px rgba(0, 0, 0, 0.06)",
            position: "relative",
            zIndex: 2,
            width: "97%",
            height: isMobile ? 200 : 220,
            overflow: "hidden",
          }}
        >
          <img
            src={product.icon}
            alt={product.name}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: isMobile ? "1rem" : "1.25rem",
              display: "block",
            }}
          />
        </Box>
      </Box>

      {/* Content section */}
      <Box
        sx={{
          p: isMobile ? "1.5rem" : "1rem 1.5rem 2rem",
          background:
            "linear-gradient(113.1deg, rgba(24, 92, 183, 0.06) 0%, rgba(205, 48, 77, 0.06) 100%)",
          display: "flex",
          flexDirection: "column",
          flex: "0 0 auto",
          minHeight: isMobile ? "auto" : "250px",
          position: "relative",
          zIndex: 2,
          justifyContent: "space-between",
          gap: isMobile ? "1rem" : "1.25rem",
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: isMobile ? "1.125rem" : "1.375rem",
              fontWeight: 700,
              lineHeight: "130%",
              color: "#040815",
              textAlign: "center",
              mb: isMobile ? "0.75rem" : "1rem",
            }}
          >
            {product.name}
          </Typography>
          <Typography
            sx={{
              fontSize: isMobile ? "0.9375rem" : "1rem",
              fontWeight: 400,
              lineHeight: "160%",
              color: "#525252",
              textAlign: "center",
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {product.description}
          </Typography>
        </Box>

        <Button
          variant="contained"
          sx={{
            width: "100%",
            maxWidth: isMobile ? "10rem" : "12.5rem",
            minHeight: isMobile ? "2.75rem" : "3.125rem",
            color: "#ffffff",
            background: "linear-gradient(90deg, #185CB7 0%, #1565C0 100%)",
            textTransform: "none",
            fontSize: isMobile ? "1rem" : "1.125rem",
            borderRadius: isMobile ? "0.75rem" : "0.875rem",
            padding: isMobile ? "0.625rem 1.5rem" : "0.875rem 1.75rem",
            boxShadow: "0 4px 12px rgba(24, 92, 183, 0.3)",
            fontWeight: "600",
            mx: "auto",
            "&:hover": {
              background: "linear-gradient(90deg, #1565C0 0%, #185CB7 100%)",
              boxShadow: "0 6px 16px rgba(24, 92, 183, 0.4)",
            },
            "&:disabled": {
              background: "#E0E0E0",
              color: "#9E9E9E",
            },
          }}
          onClick={() =>
            product.navigationLink && onNavigate(product.navigationLink)
          }
          disabled={!product.navigationLink}
        >
          Explore
        </Button>
      </Box>
    </Box>
  </Box>
);

const Dashboard = () => {
  const navigate = useNavigate();
  const { open } = useOutletContext();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  return (
    <Box
      sx={{
        flexGrow: 1,
        p: isMobile ? 2 : 3,
        width: isMobile
          ? "100%"
          : open
          ? "calc(100% - 280px)"
          : "calc(100% - 100px)",
        marginLeft: isMobile ? "0" : open ? "280px" : "100px",
        transition: "margin 0.3s ease",
        height: "100vh",
        display: "flex",
        background: "#f9f9f9",
      }}
    >
      <Box
        mt={10}
        style={{
          borderRadius: "12px",
          textAlign: "center",
          width: "100%",
          height: "calc(100% - 75px)",
          marginLeft: open ? "" : "1em",
          overflow: "hidden",
          background: "#FFFFFF",
        }}
      >
        <Box
          style={{
            borderRadius: "12px",
            textAlign: "center",
            width: "100%",
            height: "calc(100% - 5px)",
            overflow: "auto",
            background:
              "linear-gradient(92.43deg, rgba(24, 92, 183, 0.08) 30.42%, rgba(205, 48, 77, 0.08) 100%)",
            border: "2px solid white",
          }}
        >
          {/* Hero Section with Meon Docs */}
          <Box
            sx={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              pb: isMobile ? 2 : 2,
              pt: isMobile ? 2 : 2,
              minHeight: isMobile ? "auto" : "55vh",
              maxHeight: isMobile ? "auto" : "55vh",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: isMobile ? "20px 20px 0 20px" : "10px 20px 10px 60px",
                gap: isMobile ? "30px" : "60px",
                flexDirection: isMobile ? "column" : "row",
                width: "100%",
                height: "100%",
              }}
            >
              {/* Left Content Section */}
              <Box
                sx={{
                  textAlign: "left",
                }}
              >
                <Box sx={{ width: isMobile ? "100%" : "38%" }}>
                  <Typography
                    sx={{
                      display: "inline-block", // important: shrink to text width
                      fontSize: isMobile ? "32px" : "40px",
                      fontWeight: 700,
                      lineHeight: isMobile ? "40px" : "48px",
                      paddingBottom: "2px",
                      background:
                        "linear-gradient(90deg, #185CB7 0%, #C11540 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                      color: "transparent",
                    }}
                  >
                    Meon Docs
                  </Typography>
                </Box>

                {/* Subtitle */}
                <Typography
                  sx={{
                    fontSize: isMobile ? "15px" : "18px",
                    fontWeight: 400,
                    lineHeight: "160%",
                    color: "#1D1D1D",
                    mt: isMobile ? "16px" : "20px",
                  }}
                >
                  Welcome to Meon's unified documentation portal — designed to
                  help developers and businesses integrate seamlessly with our
                  APIs.
                </Typography>

                {/* What You'll Find Inside Section */}
                <Box
                  sx={{
                    mt: isMobile ? "20  px" : "24px",

                    padding: isMobile ? "14px" : "10px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: isMobile ? "18px" : "20px",
                      fontWeight: 600,
                      color: "#1D1D1D",
                      mb: isMobile ? "16px" : "20px",
                    }}
                  >
                    What You'll Find Inside:
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: isMobile ? "12px" : "16px",
                    }}
                  >
                    {[
                      {
                        icon: startSvg,
                        title: "Quickstarts & Setup Guides",
                      },
                      {
                        icon: startSvg,
                        title: "Multi-language SDKs",
                      },
                      {
                        icon: startSvg,
                        title: "Live API Playground",
                      },
                    ].map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: isMobile ? "12px" : "16px",
                        }}
                      >
                        <Box
                          sx={{
                            width: isMobile ? "20px" : "24px",
                            height: isMobile ? "20px" : "24px",
                            flexShrink: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={item.icon}
                            alt="star"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </Box>
                        <Typography
                          sx={{
                            fontSize: isMobile ? "14px" : "16px",
                            fontWeight: 500,
                            color: "#1D1D1D",
                            lineHeight: "150%",
                          }}
                        >
                          {item.title}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>

              {/* Right Image Section */}
              <Box
                sx={{ display: "flex", maxHeight: isMobile ? "auto" : "50vh" }}
              >
                {isMobile ? (
                  <img
                    src={HeroMeonDocs}
                    alt="Meon Docs"
                    style={{
                      maxHeight: "40vh",
                      width: "auto",
                      objectFit: "contain",
                    }}
                  />
                ) : (
                  <img
                    src={HeroMeonDocs}
                    alt="Meon Docs"
                    style={{
                      maxHeight: "50vh",
                      height: "auto",
                      width: "auto",
                      objectFit: "contain",
                    }}
                  />
                )}
              </Box>
            </Box>

            {/* Scroll Indicator - Positioned at Bottom */}
            <Box
              sx={{
                position: "absolute",
                bottom: isMobile ? "5px" : "10px",
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 0.5,
                cursor: "pointer",
                zIndex: 10,
                animation: "bounce 2s infinite",
                "@keyframes bounce": {
                  "0%, 100%": {
                    transform: "translateX(-50%) translateY(0)",
                  },
                  "50%": {
                    transform: "translateX(-50%) translateY(-10px)",
                  },
                },
                "&:hover": {
                  "& .scroll-text": {
                    color: "#C11540",
                  },
                  "& .scroll-arrow": {
                    borderColor: "#C11540",
                  },
                },
              }}
              onClick={() => {
                const productsSection = document.querySelector(
                  '[data-section="products"]'
                );
                if (productsSection) {
                  productsSection.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }
              }}
            >
              {/* <Typography
                className="scroll-text"
                sx={{
                  fontSize: isMobile ? "11px" : "13px",
                  fontWeight: 600,
                  color: "#185CB7",
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                  transition: "color 0.3s ease",
                }}
              >
                Explore
              </Typography> */}
              {/* <Box
                className="scroll-arrow"
                sx={{
                  width: "24px",
                  height: "24px",
                  borderLeft: "2.5px solid #185CB7",
                  borderBottom: "2.5px solid #185CB7",
                  transform: "rotate(-45deg)",
                  transition: "border-color 0.3s ease",
                }}
              /> */}
            </Box>
          </Box>

          {/* Products Section */}
          <Box
            data-section="products"
            sx={{
              background: "#FFFFFF",
              borderTopLeftRadius: isMobile ? "40px" : "60px",
              borderTopRightRadius: isMobile ? "40px" : "60px",
              py: isMobile ? 3 : 2,
              px: isMobile ? 2 : 4,
              mt: isMobile ? 0 : 0,
            }}
          >
            {/* Products Header */}
            <Box
              sx={{
                textAlign: "center",
                mb: isMobile ? 3 : 1,
              }}
            >
              <Typography
                sx={{
                  fontSize: isMobile ? "1.75rem" : "2.5rem",
                  fontWeight: 700,
                  lineHeight: "150%",
                  color: "#040815",
                  mb: isMobile ? 1 : 0,
                }}
              >
                Our Products
              </Typography>
              <Typography
                sx={{
                  fontSize: isMobile ? "0.9375rem" : "1rem",
                  fontWeight: 400,
                  lineHeight: "150%",
                  color: "#454545",
                  maxWidth: "800px",
                  mx: "auto",
                  px: isMobile ? 2 : 0,
                  mb: isMobile ? 2 : 5,
                }}
              >
                Powering your workflows with secure, fast, and reliable
                verification APIs from Meon.
              </Typography>
            </Box>

            {/* Products Grid */}
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
                gap: isMobile ? 2 : isTablet ? 3 : 4,
                justifyItems: "center",
                maxWidth: "1400px",
                mx: "auto",
              }}
            >
              {products.map((product) => (
                <ProductCard
                  key={product.id}
                  product={product}
                  onNavigate={navigate}
                  isMobile={isMobile}
                  isTablet={isTablet}
                />
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
